/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Crosspostingplatformshint2Inputs */

const en_crosspostingplatformshint2 = /** @type {(inputs: Crosspostingplatformshint2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose where to publish this post.`)
};

const de_crosspostingplatformshint2 = /** @type {(inputs: Crosspostingplatformshint2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wähle aus, wo dieser Beitrag veröffentlicht werden soll.`)
};

/**
* | output |
* | --- |
* | "Choose where to publish this post." |
*
* @param {Crosspostingplatformshint2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const crosspostingplatformshint2 = /** @type {((inputs?: Crosspostingplatformshint2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Crosspostingplatformshint2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_crosspostingplatformshint2(inputs)
	return de_crosspostingplatformshint2(inputs)
});
export { crosspostingplatformshint2 as "crosspostingPlatformsHint" }